import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './auth-context';

/** Reads the current user. Throws if used outside the provider, which is a bug. */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>.');
  }
  return context;
}
